// @flow

import { RadioButton, RadioGroup, TextField } from '@fil-global/eiswurfel';
import React from 'react';

export const RadioGroupField = ({ options, value, ...rest }: Props) => (
  <RadioGroup {...rest} selectedValue={value}>
    {options.map((op, i) => (
      <RadioButton {...op} key={i.toString()} variation="small" />
    ))}
  </RadioGroup>
);

export const TextInputField = props => <TextField {...props} />;
